module.exports = __webpack_public_path__ + "static/media/girls.dcd97c37.mp4";